import React from 'react';
import { withRouter } from 'react-router-dom';
import { useStoreState } from "easy-peasy";
import LogIn from './LogIn';

function Home (props) {
  const current_domain = useStoreState(state => state.current_domain);
  const is_logged_in = useStoreState(state => state.is_logged_in);

  return (
    <>
    {!is_logged_in &&
      <>
      <div id="content" className="container py-5">
            <LogIn/>
      </div>
     </>
    }
    {is_logged_in &&
      <>
      <div id="content" className="container py-5">
        <div className="row pt-5 mt-4">
          <div className="col-md-6">
            <h2 className="h4"><i className="fa-solid fa-tachograph-digital"></i> Dashboard</h2>
          </div>
        </div>

        <div className="row mt-4">
          {/*
            <div className="col">
            <div className="card h-100">
              <div className="card-header bg-dark h4 text-white">
                Choose Your Link
              </div>
              <div className="card-body">
                <div className="input-group">
                  <select className="form-select" id="chooseSelect" aria-label="Choose your domain">
                    <option selected>Choose...</option>
                    <option value="1">One</option>
                    <option value="2">Two</option>
                    <option value="3">Three</option>
                  </select>
                  <button class="btn btn-danger" type="button">Submit</button>
                </div>
                  { false && <a href="/" className="btn btn-danger">Order More</a> }
              </div>
            </div>
          </div>
          */}
          <div className="col">
            <div className="card h-100">
              <div className="card-header bg-dark h4 text-white">
                How To Use
              </div>
              <div className="card-body">
                <ol>
                  <li><strong>Compose Your Email:</strong> Open up your favorite email client or email marketing tool and send that completed message to <a href="mailto:anything@linkoln.link">anything@linkoln.link</a></li>
                  <li><strong>Start Sending:</strong> You're all set! Copy the link from the email sent in reply to your request.</li>
                </ol>
                <p>Compose, send, and receive Linkoln Links to your heart's content. For example, you will be able to create a public link such as "{current_domain.domain}/123ABC," by sending an email from the email you registered with to "<a href="mailto:anything@linkoln.link">anything@linkoln.link</a>". Simple, right?</p>
                <p><small className="text-danger fst-italic">*please note that the ‘from address’ must match the same address that you confirmed your registration with. Our subdomain links are public web domains used for LINKOLN Email. <br/><br/>Need Help?<br/>Contact Support.<br/><a href="mailto:support@linkoln.io">support@linkoln.io</a><br/><a href="tel:3126516626;1">312-651-6626 Ext 1</a></small></p>
              </div>
            </div>
          </div>
        </div>
      </div>
      </>
    }
  </>);
}

export default withRouter(Home);
